import { render } from "./NotificationToggle.vue.js?vue&type=template&id=dbce0ffa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationToggle.vue?vue&type=template&id=dbce0ffa"
import script from "./NotificationToggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationToggle.vue?vue&type=script&lang=js"
export * from "./NotificationToggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/components/notifications/NotificationToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbce0ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbce0ffa', __exports__)) {
    api.reload('dbce0ffa', __exports__)
  }
  
  module.hot.accept("./NotificationToggle.vue.js?vue&type=template&id=dbce0ffa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NotificationToggle.vue?vue&type=template&id=dbce0ffa", () => {
    api.rerender('dbce0ffa', render)
  })

}


export default __exports__